/**
 * Aplica el cupón sobre la base descontable. Porcentual: descuento redondeado hacia abajo.
 * El resultado nunca baja de 0 y sin base no se descuenta nada.
 */
export const getTotal = ({ campaignType, total, campaignValue }) => {
  const base = Number(total) || 0
  if (base <= 0) return base
  const value = Number(campaignValue) || 0
  const discount = campaignType == "value"
    ? value
    : Math.floor((base * value) / 100);
  return Math.max(0, base - discount);
};

export const getStatus = (status) => {
  const allStatus = {
    0: "Active",
    1: "Solicited",
    2: "Redeemed",
  };

  return allStatus.hasOwnProperty(status) ? allStatus[status] : allStatus[0];
};
